import {
  ADMIN_LOGIN,
  ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGIN_FAILURE,
  ADMIN_GET_ALL_TERMINALS_SUCCESS,
  ADMIN_GET_ALL_TERMINALS_FAILURE,
  ADMIN_GET_ALL_TERMINALS,
  ADMIN_SET_ACTIVE_TERMINAL,
  ADMIN_SAVE_TERMINAL,
  ADMIN_SAVE_TERMINAL_SUCCESS,
  ADMIN_SAVE_TERMINAL_FAILURE,
  ADMIN_SET_LOGIN_ERROR_MESSAGE,
  ADMIN_GET_UI_CONFIG,
  ADMIN_SET_UI_CONFIG,
  ADMIN_GET_UI_CONFIG_SUCCESS,
  ADMIN_GET_UI_CONFIG_FAILURE,
  ADMIN_SET_UI_CONFIG_FAILURE,
  ADMIN_GET_DEPARTURES,
  ADMIN_GET_DEPARTURES_SUCCESS,
  ADMIN_GET_DEPARTURES_FAILURE,
  ADMIN_UPDATE_DEPARTURE,
  ADMIN_UPDATE_DEPARTURE_SUCCESS,
  ADMIN_UPDATE_DEPARTURE_FAILURE,
  ADMIN_TOGGLE_OPENING_LOCATION_SETTINGS,
  ADMIN_TOGGLE_OPENING_TERMINALS,
  ADMIN_TOGGLE_OPENING_DEPARTURES,
  ADMIN_GET_PAIRS_SUCCESS,
  ADMIN_GET_PAIRS_FAILURE,
} from '../constants/admin/adminActions'
import { Terminal } from '../types/terminal'
import { UiConfig } from '../types/uiConfig'
import { Departure } from '../types/departures'
import _ from 'lodash'

interface State {
  isLoginLoading: boolean
  isDepartureLoading: boolean
  isUiConfigLoading: boolean
  isGetAllTerminalsLoading: boolean
  isTerminalSaving: boolean
  error: string
  terminals: Terminal[]
  terminalEdit?: Terminal
  isShowErrorLogin: boolean
  uiConfig: UiConfig | null
  departures: Departure[]
  isLocationsSettingsOpened: boolean
  isTerminalsOpened: boolean
  isDeparturesOpened: boolean
  pairs: string[]
}
const initialState: State = {
  isLoginLoading: false,
  isDepartureLoading: false,
  isUiConfigLoading: false,
  isGetAllTerminalsLoading: false,
  isTerminalSaving: false,
  error: '',
  terminals: [],
  terminalEdit: undefined,
  isShowErrorLogin: false,
  uiConfig: null,
  departures: [],
  isLocationsSettingsOpened: false,
  isTerminalsOpened: false,
  isDeparturesOpened: false,
  pairs: [],
}
const reducer = (state: State = initialState, action: any): State => {
  switch (action.type) {
    case ADMIN_LOGIN:
      return { ...state, isShowErrorLogin: false, isLoginLoading: true }
    case ADMIN_SET_LOGIN_ERROR_MESSAGE:
      return { ...state, isShowErrorLogin: true, isLoginLoading: false }
    case ADMIN_LOGIN_SUCCESS:
    case ADMIN_LOGIN_FAILURE:
      return { ...state, isShowErrorLogin: false, isLoginLoading: false }
    case ADMIN_GET_ALL_TERMINALS:
      return { ...state, isGetAllTerminalsLoading: true, error: '' }
    case ADMIN_GET_ALL_TERMINALS_SUCCESS:
      return { ...state, terminals: action.payload, isGetAllTerminalsLoading: false, error: '' }
    case ADMIN_GET_ALL_TERMINALS_FAILURE:
      return { ...state, error: 'cannot load list of terminals', isGetAllTerminalsLoading: false }
    case ADMIN_SET_ACTIVE_TERMINAL:
      return { ...state, terminalEdit: _.cloneDeep(action.payload) }
    case ADMIN_SAVE_TERMINAL:
      return { ...state, isTerminalSaving: true, error: '' }
    case ADMIN_SAVE_TERMINAL_SUCCESS: {
      return {
        ...state,
        terminals: _.map(state.terminals, (item) => (item.id === action.payload.id ? action.payload : item)),
        isTerminalSaving: false,
        error: '',
      }
    }
    case ADMIN_SAVE_TERMINAL_FAILURE:
      return { ...state, error: 'cannot save terminal edited fields', isTerminalSaving: false }
    case ADMIN_SET_UI_CONFIG:
    case ADMIN_GET_UI_CONFIG:
      return { ...state, isUiConfigLoading: true, error: '' }
    case ADMIN_GET_DEPARTURES:
    case ADMIN_UPDATE_DEPARTURE:
      return { ...state, isDepartureLoading: true, error: '' }
    case ADMIN_GET_UI_CONFIG_SUCCESS:
      return { ...state, uiConfig: action.payload, isUiConfigLoading: false, error: '' }
    case ADMIN_GET_UI_CONFIG_FAILURE:
      return { ...state, error: 'cannot load ui config', isUiConfigLoading: false }
    case ADMIN_SET_UI_CONFIG_FAILURE:
      return { ...state, error: 'cannot save uiConfig edited fields', isUiConfigLoading: false }
    case ADMIN_GET_DEPARTURES_FAILURE:
      return { ...state, error: 'cannot get departures', isDepartureLoading: false }
    case ADMIN_GET_DEPARTURES_SUCCESS:
      return {
        ...state,
        departures: action.payload,
        isDepartureLoading: false,
        error: '',
      }
    case ADMIN_UPDATE_DEPARTURE_FAILURE:
      return { ...state, error: 'cannot update departure at the server', isDepartureLoading: false }
    case ADMIN_UPDATE_DEPARTURE_SUCCESS: {
      const update = action.payload || {}
      const departures = state.departures.map((departure) => ({
        ...departure,
        closedCheckIn:
          departure.sailFromRefId === update.sailFromRefId ? update.closedCheckIn : departure.closedCheckIn,
      }))
      return {
        ...state,
        departures,
        isDepartureLoading: false,
        error: '',
      }
    }
    case ADMIN_TOGGLE_OPENING_LOCATION_SETTINGS:
      return { ...state, isLocationsSettingsOpened: !state.isLocationsSettingsOpened }
    case ADMIN_TOGGLE_OPENING_TERMINALS:
      return { ...state, isTerminalsOpened: !state.isTerminalsOpened }
    case ADMIN_TOGGLE_OPENING_DEPARTURES:
      return { ...state, isDeparturesOpened: !state.isDeparturesOpened }
    case ADMIN_GET_PAIRS_FAILURE:
      return { ...state, error: 'cannot get pier-ship pairs', pairs: [] }
    case ADMIN_GET_PAIRS_SUCCESS:
      return {
        ...state,
        pairs: action.payload,
        error: '',
      }

    default:
      return state
  }
}

export default reducer
